import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router/index.js'
import i18n from './i18n/index.js'

import AeVue from '@aevue/components'
import '@aevue/components/dist/aevue.css'
import '@aevue/components/themes/glass.css'
import '@aevue/components/themes/form-glass.css'
import './styles/local-theme.css'

const app = createApp(App)

app.use(AeVue)
app.use(createPinia())
app.use(i18n)
app.use(router)

app.mount('#app')
